// extracted by mini-css-extract-plugin
export default {"root":"Root_root__F-UYY","root__inner":"Root_root__inner__YCRsh","root--has_menu":"Root_root--has_menu__uu9Yg","spin":"Root_spin__1E5RL"};